import { all, takeLatest } from "redux-saga/effects";

import {
    APPROVE_DEMANDE_RECRUTEMENT_REQUEST,
    CANCEL_DEMANDE_RECRUTEMENT_REQUEST,
    CREATE_DEMANDE_RECRUTEMENT_REQUEST,
    DELETE_DEMANDE_RECRUTEMENT_REQUEST,
    FETCH_DEMANDES_RECRUTEMENT_REQUEST,
    REJECT_DEMANDE_RECRUTEMENT_REQUEST, SAVE_DEMANDE_RECRUTEMENT_CIBLAGE_REQUEST,
    SEND_DEMANDE_RECRUTEMENT_CIBLAGE_REQUEST,
    SEND_OFFER_TO_CHASSEURS_REQUEST,
    SEND_OFFER_TO_PARTENAIRES_REQUEST,
    UPDATE_DEMANDE_RECRUTEMENT_REQUEST,
} from "../../actions/demandesRecrutementActions";
import {
    approveDemandeRecrutementSaga,
    cancelDemandeRecrutementSaga,
    createDemandeRecrutementSaga,
    deleteDemandeRecrutementSaga,
    fetchDemandesRecrutementSaga,
    rejectDemandeRecrutementSaga, saveDemandeRecrutementCiblageSaga, sendDemandeRecrutementCiblageSaga,
    sendOfferToChasseursSaga,
    sendOfferToPartenairesSaga,
    updateDemandeRecrutementSaga,
} from "../../sagas/demandesRecrutementSagas";

import {
  CREATE_CHASSEUR_REQUEST,
  DELETE_CHASSEUR_REQUEST,
  FETCH_CHASSEURS_REQUEST,
  FETCH_DOMAINES_REQUEST,
  UPDATE_CHASSEUR_REQUEST,
} from "../../actions/chasseursActions";
import {
  createChasseurSaga,
  deleteChasseurSaga,
  fetchChasseursSaga,
  fetchDomainesSaga,
  updateChasseurSaga,
} from "../../sagas/chasseursSaga";

import {
  CREATE_PARTENAIRE_ACAD_REQUEST,
  DELETE_PARTENAIRE_ACAD_REQUEST,
  FETCH_PARTENAIRES_ACAD_REQUEST,
  UPDATE_PARTENAIRE_ACAD_REQUEST,
} from "../../actions/partenairesAcademiquesActions";
import {
  createPartenaireAcadSaga,
  deletePartenaireAcadSaga,
  fetchPartenairesAcadSaga,
  updatePartenaireAcadSaga,
} from "../../sagas/partenairesAcademiquesSaga";

import {
  CREATE_ETABLISSEMENT_REQUEST,
  DELETE_ETABLISSEMENT_REQUEST,
  FETCH_ETABLISSEMENTS_REQUEST,
  UPDATE_ETABLISSEMENT_REQUEST,
} from "../../actions/etablissementsActions";
import {
  createEtablissementSaga,
  deleteEtablissementSaga,
  fetchEtablissementsSaga,
  updateEtablissementSaga,
} from "../../sagas/etablissementsSagas";

import {
  CREATE_CANDIDAT_REQUEST,
  DELETE_CANDIDAT_REQUEST,
  FETCH_CANDIDATS_REQUEST,
  UPDATE_CANDIDAT_REQUEST,
} from "../../actions/candidatsActions";
import {
  createCandidatSaga,
  deleteCandidatSaga,
  fetchCandidatsSaga,
  updateCandidatSaga,
} from "../../sagas/candidatsSaga";

import {
  ANNULER_CANDIDATURE_REQUEST,
  CREATE_CANDIDATURE_REQUEST,
  DELETE_CANDIDATURE_REQUEST,
  FETCH_CANDIDATURES_BY_CANDIDAT_REQUEST,
  FETCH_CANDIDATURES_BY_DEMANDE_REQUEST,
  FETCH_CANDIDATURES_REQUEST,
  FETCH_CANDIDATURE_REQUEST,
  REJETER_CANDIDATURE_REQUEST,
  UPDATE_CANDIDATURE_REQUEST,
  VALIDER_CANDIDATURE_REQUEST,
} from "../../actions/candidaturesActions";
import {
  annulerCandidatureSaga,
  createCandidatureSaga,
  deleteCandidatureSaga,
  fetchCandidaturesByCandidatSaga,
  fetchCandidaturesByDemandeSaga,
  fetchCandidatureSaga,
  fetchCandidaturesSaga,
  rejeterCandidatureSaga,
  updateCandidatureSaga,
  validerCandidatureSaga,
} from "../../sagas/candidaturesSaga";

import {
  FETCH_SAVED_CANDIDATES_BY_DEMANDE_REQUEST,
  SAVE_CANDIDATE_FOR_DEMANDE_REQUEST,
  UNSAVE_CANDIDATE_FOR_DEMANDE_REQUEST,
} from "../../actions/demandeCandidatSauvegardeActions";
import {
  fetchSavedCandidatesByDemandeSaga,
  saveCandidateForDemandeSaga,
  unsaveCandidateForDemandeSaga,
} from "../../sagas/demandeCandidatSauvegardeSaga";

import {
  CREATE_ENTRETIEN_REQUEST,
  FETCH_ENTRETIENS_BY_CANDIDATURE_REQUEST,
  SEND_INTERVIEW_CALENDAR_REQUEST,
  UPDATE_ENTRETIEN_REQUEST,
} from "../../actions/entretiensActions";
import {
  createEntretienSaga,
  fetchEntretiensByCandidatureSaga,
  sendInterviewCalendarSaga,
  updateEntretienSaga,
} from "../../sagas/entretiensSaga";

import {
  CREATE_OFFRE_SALARIALE_REQUEST,
  DELETE_OFFRE_SALARIALE_REQUEST,
  DOWNLOAD_OFFRE_SALARIALE_DOCUMENT_REQUEST,
  FETCH_OFFRE_SALARIALE_BY_CANDIDATURE_REQUEST,
  SEND_OFFRE_SALARIALE_EMAIL_REQUEST,
  UPDATE_OFFRE_SALARIALE_REQUEST,
} from "../../actions/offresSalarialesActions";
import {
  createOffreSalarialeSaga,
  deleteOffreSalarialeSaga,
  downloadOffreSalarialeDocumentSaga,
  fetchOffreSalarialeByCandidatureSaga,
  sendOffreSalarialeEmailSaga,
  updateOffreSalarialeSaga,
} from "../../sagas/offresSalarialesSagas";

import {
  CHANGE_EVALUATION_STATUS_REQUEST,
  CREATE_EVALUATION_REQUEST,
  DELETE_EVALUATION_REQUEST,
  GET_ALL_EVALUATIONS_REQUEST,
  GET_EVALUATIONS_BY_TYPE_REQUEST,
  GET_EVALUATION_REQUEST,
  UPDATE_EVALUATION_REQUEST,
} from "../../actions/evaluationActions";
import {
  changeEvaluationStatusSaga,
  createEvaluationSaga,
  deleteEvaluationSaga,
  getAllEvaluationsSaga,
  getEvaluationsByTypeSaga,
  getEvaluationSaga,
  updateEvaluationSaga,
} from "../../sagas/evaluationSaga";
import {
    fetchOffreEmploiByDemandeSaga,
    generateOffreEmploiSaga,
    publishOffreEmploiCareersSaga, saveOffreEmploiDraftSaga
} from "../offresEmploiSaga";
import {
    FETCH_OFFRE_EMPLOI_BY_DEMANDE_REQUEST,
    GENERATE_OFFRE_EMPLOI_REQUEST, PUBLISH_OFFRE_EMPLOI_CAREERS_REQUEST,
    SAVE_OFFRE_EMPLOI_DRAFT_REQUEST
} from "../../actions/offresEmploiActions";
import {
  EXPORT_PRE_EMBAUCHE_DOCUMENT_PDF_REQUEST,
  FETCH_PRE_EMBAUCHE_DOCUMENT_REQUEST,
  GENERATE_PRE_EMBAUCHE_DOCUMENT_REQUEST,
  UPDATE_PRE_EMBAUCHE_DOCUMENT_REQUEST,
  UPDATE_PRE_EMBAUCHE_PROCEDURE_STEP_REQUEST,
} from "../../actions/preEmbaucheActions";
import {
  fetchPreEmbaucheDocumentSaga,
  generatePreEmbaucheDocumentSaga,
  updatePreEmbaucheDocumentSaga,
  exportPreEmbaucheDocumentPdfSaga,
  updatePreEmbaucheProcedureStepSaga,
} from "../../sagas/preEmbaucheSaga";
import {
  CREATE_COMPETENCE_GENERIQUE_REQUEST, DELETE_COMPETENCE_GENERIQUE_REQUEST,
  FETCH_COMPETENCES_GENERIQUES_REQUEST, UPDATE_COMPETENCE_GENERIQUE_REQUEST
} from "../../actions/competencesGeneriquesActions";
import {
  createCompetenceGeneriqueSaga, deleteCompetenceGeneriqueSaga,
  fetchCompetencesGeneriquesSaga,
  updateCompetenceGeneriqueSaga
} from "../competencesGeneriquesSaga";

export default function* recrutementRootSaga() {
  yield all([
    takeLatest(FETCH_DEMANDES_RECRUTEMENT_REQUEST, fetchDemandesRecrutementSaga),
    takeLatest(CREATE_DEMANDE_RECRUTEMENT_REQUEST, createDemandeRecrutementSaga),
    takeLatest(UPDATE_DEMANDE_RECRUTEMENT_REQUEST, updateDemandeRecrutementSaga),
    takeLatest(DELETE_DEMANDE_RECRUTEMENT_REQUEST, deleteDemandeRecrutementSaga),
    takeLatest(APPROVE_DEMANDE_RECRUTEMENT_REQUEST, approveDemandeRecrutementSaga),
    takeLatest(REJECT_DEMANDE_RECRUTEMENT_REQUEST, rejectDemandeRecrutementSaga),
    takeLatest(CANCEL_DEMANDE_RECRUTEMENT_REQUEST, cancelDemandeRecrutementSaga),
    takeLatest(SEND_OFFER_TO_CHASSEURS_REQUEST, sendOfferToChasseursSaga),
    takeLatest(SEND_OFFER_TO_PARTENAIRES_REQUEST, sendOfferToPartenairesSaga),

    takeLatest(FETCH_CHASSEURS_REQUEST, fetchChasseursSaga),
    takeLatest(CREATE_CHASSEUR_REQUEST, createChasseurSaga),
    takeLatest(UPDATE_CHASSEUR_REQUEST, updateChasseurSaga),
    takeLatest(DELETE_CHASSEUR_REQUEST, deleteChasseurSaga),
    takeLatest(FETCH_DOMAINES_REQUEST, fetchDomainesSaga),

    takeLatest(FETCH_PARTENAIRES_ACAD_REQUEST, fetchPartenairesAcadSaga),
    takeLatest(CREATE_PARTENAIRE_ACAD_REQUEST, createPartenaireAcadSaga),
    takeLatest(UPDATE_PARTENAIRE_ACAD_REQUEST, updatePartenaireAcadSaga),
    takeLatest(DELETE_PARTENAIRE_ACAD_REQUEST, deletePartenaireAcadSaga),

    takeLatest(FETCH_ETABLISSEMENTS_REQUEST, fetchEtablissementsSaga),
    takeLatest(CREATE_ETABLISSEMENT_REQUEST, createEtablissementSaga),
    takeLatest(UPDATE_ETABLISSEMENT_REQUEST, updateEtablissementSaga),
    takeLatest(DELETE_ETABLISSEMENT_REQUEST, deleteEtablissementSaga),

    takeLatest(FETCH_CANDIDATS_REQUEST, fetchCandidatsSaga),
    takeLatest(CREATE_CANDIDAT_REQUEST, createCandidatSaga),
    takeLatest(UPDATE_CANDIDAT_REQUEST, updateCandidatSaga),
    takeLatest(DELETE_CANDIDAT_REQUEST, deleteCandidatSaga),

    takeLatest(GET_EVALUATION_REQUEST, getEvaluationSaga),
    takeLatest(GET_ALL_EVALUATIONS_REQUEST, getAllEvaluationsSaga),
    takeLatest(GET_EVALUATIONS_BY_TYPE_REQUEST, getEvaluationsByTypeSaga),
    takeLatest(CREATE_EVALUATION_REQUEST, createEvaluationSaga),
    takeLatest(UPDATE_EVALUATION_REQUEST, updateEvaluationSaga),
    takeLatest(DELETE_EVALUATION_REQUEST, deleteEvaluationSaga),
    takeLatest(CHANGE_EVALUATION_STATUS_REQUEST, changeEvaluationStatusSaga),

    takeLatest(FETCH_CANDIDATURES_REQUEST, fetchCandidaturesSaga),
    takeLatest(FETCH_CANDIDATURE_REQUEST, fetchCandidatureSaga),
    takeLatest(FETCH_CANDIDATURES_BY_DEMANDE_REQUEST, fetchCandidaturesByDemandeSaga),
    takeLatest(FETCH_CANDIDATURES_BY_CANDIDAT_REQUEST, fetchCandidaturesByCandidatSaga),
    takeLatest(CREATE_CANDIDATURE_REQUEST, createCandidatureSaga),
    takeLatest(UPDATE_CANDIDATURE_REQUEST, updateCandidatureSaga),
    takeLatest(ANNULER_CANDIDATURE_REQUEST, annulerCandidatureSaga),
    takeLatest(REJETER_CANDIDATURE_REQUEST, rejeterCandidatureSaga),
    takeLatest(VALIDER_CANDIDATURE_REQUEST, validerCandidatureSaga),
    takeLatest(DELETE_CANDIDATURE_REQUEST, deleteCandidatureSaga),
    takeLatest(FETCH_SAVED_CANDIDATES_BY_DEMANDE_REQUEST, fetchSavedCandidatesByDemandeSaga),
    takeLatest(SAVE_CANDIDATE_FOR_DEMANDE_REQUEST, saveCandidateForDemandeSaga),
    takeLatest(UNSAVE_CANDIDATE_FOR_DEMANDE_REQUEST, unsaveCandidateForDemandeSaga),

    takeLatest(FETCH_ENTRETIENS_BY_CANDIDATURE_REQUEST, fetchEntretiensByCandidatureSaga),
    takeLatest(CREATE_ENTRETIEN_REQUEST, createEntretienSaga),
    takeLatest(UPDATE_ENTRETIEN_REQUEST, updateEntretienSaga),
    takeLatest(SEND_INTERVIEW_CALENDAR_REQUEST, sendInterviewCalendarSaga),

    takeLatest(FETCH_OFFRE_SALARIALE_BY_CANDIDATURE_REQUEST, fetchOffreSalarialeByCandidatureSaga),
    takeLatest(CREATE_OFFRE_SALARIALE_REQUEST, createOffreSalarialeSaga),
    takeLatest(UPDATE_OFFRE_SALARIALE_REQUEST, updateOffreSalarialeSaga),
    takeLatest(DELETE_OFFRE_SALARIALE_REQUEST, deleteOffreSalarialeSaga),
    takeLatest(DOWNLOAD_OFFRE_SALARIALE_DOCUMENT_REQUEST, downloadOffreSalarialeDocumentSaga),
    takeLatest(SEND_OFFRE_SALARIALE_EMAIL_REQUEST, sendOffreSalarialeEmailSaga),

       takeLatest(SAVE_DEMANDE_RECRUTEMENT_CIBLAGE_REQUEST, saveDemandeRecrutementCiblageSaga),
     takeLatest(SEND_DEMANDE_RECRUTEMENT_CIBLAGE_REQUEST, sendDemandeRecrutementCiblageSaga),

     takeLatest(FETCH_OFFRE_EMPLOI_BY_DEMANDE_REQUEST, fetchOffreEmploiByDemandeSaga),
     takeLatest(GENERATE_OFFRE_EMPLOI_REQUEST, generateOffreEmploiSaga),
     takeLatest(SAVE_OFFRE_EMPLOI_DRAFT_REQUEST, saveOffreEmploiDraftSaga),
     takeLatest(PUBLISH_OFFRE_EMPLOI_CAREERS_REQUEST, publishOffreEmploiCareersSaga),

     takeLatest(FETCH_PRE_EMBAUCHE_DOCUMENT_REQUEST, fetchPreEmbaucheDocumentSaga),
     takeLatest(GENERATE_PRE_EMBAUCHE_DOCUMENT_REQUEST, generatePreEmbaucheDocumentSaga),
     takeLatest(UPDATE_PRE_EMBAUCHE_DOCUMENT_REQUEST, updatePreEmbaucheDocumentSaga),
     takeLatest(EXPORT_PRE_EMBAUCHE_DOCUMENT_PDF_REQUEST, exportPreEmbaucheDocumentPdfSaga),
     takeLatest(UPDATE_PRE_EMBAUCHE_PROCEDURE_STEP_REQUEST, updatePreEmbaucheProcedureStepSaga),


    yield takeLatest(FETCH_COMPETENCES_GENERIQUES_REQUEST, fetchCompetencesGeneriquesSaga),
    yield takeLatest(CREATE_COMPETENCE_GENERIQUE_REQUEST, createCompetenceGeneriqueSaga),
    yield takeLatest(UPDATE_COMPETENCE_GENERIQUE_REQUEST, updateCompetenceGeneriqueSaga),
    yield takeLatest(DELETE_COMPETENCE_GENERIQUE_REQUEST, deleteCompetenceGeneriqueSaga),

]);
}
